import styleSelect  from '../libs/style-select';
export default () => {
    let elSelector = ".customSelect";
    let elements = document.querySelectorAll(elSelector);

    if (elements.length) {
        elements.forEach((item, i) => {
            styleSelect(item);
        });
    }
}
